if ($('.procurement_post').length > 0) {
    const swiper = new Swiper('.procurement_post', {
        direction: 'horizontal',
        slidesToShow: 4,
        spaceBetween: 15,
        draggable: false,
        navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
        },
        // Responsive breakpoints
        breakpoints: {
            280: {
                slidesPerView: 1,
            },
            320: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
            991: {
                slidesPerView: 2,
            },
            1280: {
                slidesPerView: 3,
            },
            1440: {
                slidesPerView: 4,
            }
        },
    });
}